import template from './pickupPoint.html';
import controller from './pickupPoint.controller.js';

const OrderAndPayPickupPointComponent = {
  restrict: 'E',
  bindings: {},
  controller,
  template
};

export default OrderAndPayPickupPointComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndPay/pickupPoint/pickupPoint.component.js
 **/